import { qportalApi } from './qportal-api';
const getDaysByMonthYearWeekNoAndAssignmentId = (dateMonthWeekNo) => {
    return qportalApi.postForm(`hoursRegistration/getWeekDaysByMonthYearWeekNoAndAssignmentId`, dateMonthWeekNo);
};
const getHoursByTimeSheetIdsForAdmin = (timeSheetIds) => {
    return qportalApi.get(`hoursRegistration/GetHoursByTimeSheetIds/${timeSheetIds}`);
};
const updateTimeSheetAndHourRegistrationStatus = (requestModel) => {
    return qportalApi.postForm(`hoursRegistration/UpdateTimeSheetAndHourRegistrationStatus/`, requestModel);
};
const registerHoursPerDay = (hoursLogged) => {
    return qportalApi.postForm(`hoursRegistration/registerHoursPerDay`, hoursLogged);
};
const bulkRegisterHours = (hoursLogged, expectedWeekVersion) => {
    const payload = {
        expectedWeekVersion,
        hoursLogged: hoursLogged.map((h) => ({
            freelancerId: undefined,
            year: h.year,
            month: h.month,
            weekNo: h.weekNo,
            assignmentId: h.assignmentId,
            assignmentReasonId: h.assignmentReasonId,
            NoOfHours: h.NoOfHours,
            date: h.date,
            Id: h.Id
        }))
    };
    return qportalApi.post(`hoursRegistration/bulkRegisterHours`, payload);
};
const getLoggedHoursPerDayById = (Id) => {
    return qportalApi.get(`hoursRegistration/${Id}/GetLoggedHoursPerDayById`);
};
const GetMonthListByAssignmentAndFreelancerId = (request) => {
    return qportalApi.get(`hoursRegistration/GetMonthListByAssignmentAndFreelancerId`, {
        params: { assignmentId: request.assignmentId, year: request.year, id: request.id }
    });
};
const getYearListByAssignmentAndFreelancerId = (request) => {
    return qportalApi.get(`hoursRegistration/GetYearListByAssignmentAndFreelancerId`, {
        params: { assignmentId: request.assignmentId, id: request.id }
    });
};
const reSyncBusinessCentralHoursByTimeSheetIds = (timeSheetIds) => {
    return qportalApi.get(`hoursRegistration/ReSyncBusinessCentralHoursByTimeSheetIds/${timeSheetIds}`);
};
const HoursRegistrationApi = {
    updateTimeSheetAndHourRegistrationStatus,
    registerHoursPerDay,
    getLoggedHoursPerDayById,
    getHoursByTimeSheetIdsForAdmin,
    bulkRegisterHours,
    getDaysByMonthYearWeekNoAndAssignmentId,
    GetMonthListByAssignmentAndFreelancerId,
    getYearListByAssignmentAndFreelancerId,
    reSyncBusinessCentralHoursByTimeSheetIds
};
export default HoursRegistrationApi;
